import SetUserPassword from './SetUserPassword';

export default SetUserPassword;
